import Vue from "vue";

const component = {
  name: "CustomMasonry",
  props: {
    tag: { type: [String], default: "div" },
    cols: { type: [Object, Number, String], default: 2 },
    gutter: { type: [Object, Number, String], default: 0 },
    css: { type: Boolean, default: true },
    columnTag: { type: String, default: "div" },
    columnClass: { type: [String, Array, Object], default: () => [] },
    columnAttr: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      displayColumns: 2,
      displayGutter: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.reCalculate();
    });
    if (window) {
      window.addEventListener("resize", this.reCalculate);
    }
  },

  updated() {
    this.$nextTick(() => {
      this.reCalculate();
    });
  },

  beforeDestroy() {
    if (window) {
      window.removeEventListener("resize", this.reCalculate);
    }
  },

  methods: {
    reCalculate() {
      const prev = this.windowWidth;
      this.windowWidth = window?.innerWidth || Infinity;
      if (prev === this.windowWidth) return;
      this._reCalculateColumnCount(this.windowWidth);
      this._reCalculateGutterSize(this.windowWidth);
    },
    _reCalculateGutterSize(width) {
      this.displayGutter = breakpointValue(this.gutter, width);
    },
    _reCalculateColumnCount(width) {
      let cols = breakpointValue(this.cols, width);
      this.displayColumns = Math.max(1, Number(cols) || 0);
    },

    // 覆写的方法
    _getChildItemsInColumnsArray() {
        // console.log("已使用自定义版本的 _getChildItemsInColumnsArray");
        const columns = Array.from({ length: this.displayColumns }, () => []);
        const columnHeights = new Array(this.displayColumns).fill(0);

        let childItems = this.$slots.default || [];

        // 支援 <transition-group>
        if (childItems.length === 1 && childItems[0].componentOptions?.tag === 'transition-group') {
            childItems = childItems[0].componentOptions.children || [];
        }

        for (let i = 0; i < childItems.length; i++) {
            const vnode = childItems[i];
            // console.log('vvvvnode',vnode.children[0].elm);

            // 忽略空白或非 tag 节点
            if (!vnode || !vnode.tag) {
                continue;
            }

            // vnode.elm 是真实 DOM 节点（在 render 后才可访问）
            // console.log('vnode',vnode);
            const el = vnode.elm;
            // console.log('el-height',el);
            let height = 0;

            // 获取真实 DOM 高度，默认为 0
            if (el && typeof el.offsetHeight === 'number') {
                height = el.offsetHeight;
                // console.log('成功获取dom高度',height);
            } else {
            // fallback: 假设高度为 1（不能延迟等图片加载完）
                height = 1;
                // console.log('没有获取dom高度，使用默认高度',height);
            }

            // 找出当前最矮列
            const minIndex = columnHeights.indexOf(Math.min(...columnHeights));

            // 添加到该列
            columns[minIndex].push(vnode);
            columnHeights[minIndex] += height;
        }

        return columns;

    },
  },

  render(h) {
    const columnsWithChildren = this._getChildItemsInColumnsArray();
    const unit =
      parseInt(this.displayGutter) === this.displayGutter * 1 ? "px" : "";
    const gutterWithUnit = `${this.displayGutter}${unit}`;
    const columnStyle = {
      boxSizing: "border-box",
      backgroundClip: "padding-box",
      width: `${100 / this.displayColumns}%`,
      border: "0 solid transparent",
      borderLeftWidth: gutterWithUnit,
    };

    const columns = columnsWithChildren.map((children, index) =>
      h(
        this.columnTag,
        {
          key: `${index}-${columnsWithChildren.length}`,
          style: this.css ? columnStyle : null,
          class: this.columnClass,
          attrs: this.columnAttr,
          ref:`column-${index}`
        },
        children
      )
    );

    const containerStyle = {
      display: ["-webkit-box", "-ms-flexbox", "flex"],
      marginLeft: `-${gutterWithUnit}`,
    };

    return h(this.tag, this.css ? { style: containerStyle } : null, columns);
  },
};

// 响应式断点计算
function breakpointValue(mixed, windowWidth) {
  const num = parseInt(mixed);
  if (num > -1) return mixed;
  if (typeof mixed !== "object") return 0;

  let matched = Infinity;
  let value = mixed.default || 0;
  for (const k in mixed) {
    const bp = parseInt(k);
    const val = parseInt(mixed[k]);
    if (isNaN(bp) || isNaN(val)) continue;
    if (windowWidth <= bp && bp < matched) {
      matched = bp;
      value = mixed[k];
    }
  }
  return value;
}

export default component;
